import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export default function AdminLeads() {
  const [leads, setLeads] = useState(null);

  const load = () => api.get("/admin/leads").then((res) => setLeads(res.data));
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/leads/${id}`, { status });
    toast.success("Lead updated");
    load();
  };

  return (
    <div data-testid="admin-leads-page">
      <h1 className="text-2xl font-serif-heading font-bold text-navy mb-6">Leads Inbox</h1>
      <div className="bg-white rounded-lg border border-slate-200 overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead><TableHead>Service</TableHead><TableHead>Contact</TableHead>
              <TableHead>City/ZIP</TableHead><TableHead>Source</TableHead><TableHead>Date</TableHead><TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {leads?.map((l) => (
              <TableRow key={l.id} data-testid={`admin-lead-row-${l.id}`}>
                <TableCell className="font-medium text-navy">{l.name}</TableCell>
                <TableCell><Badge variant="secondary">{l.service}</Badge></TableCell>
                <TableCell className="text-sm text-slate-500">{l.email}<br />{l.phone}</TableCell>
                <TableCell className="text-sm text-slate-500">{l.city} {l.zip_code}</TableCell>
                <TableCell className="text-xs text-slate-400">{l.source_page}</TableCell>
                <TableCell className="text-xs text-slate-400">{new Date(l.created_at).toLocaleDateString()}</TableCell>
                <TableCell>
                  <Select value={l.status} onValueChange={(v) => updateStatus(l.id, v)}>
                    <SelectTrigger className="w-28 h-8" data-testid={`admin-lead-status-${l.id}`}><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="new">New</SelectItem>
                      <SelectItem value="contacted">Contacted</SelectItem>
                      <SelectItem value="closed">Closed</SelectItem>
                    </SelectContent>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
            {leads?.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-slate-400 py-8">No leads yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
